module.exports = __webpack_public_path__ + "static/media/Lateral_Moderate_Z1.9a988984.png";